export const SKELETON_ITEMS_COUNT = 5

export const SUPER_ADMINISTRATOR_ROLE = 'Super Administrator'
export const SUPERADMIN_DISPLAY_ROLE = 'Superadmin'
